// require("./bootstrap");
// window.Pusher = require("pusher-js");
import { IonicVue } from "@ionic/vue";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import LongPress from "vue3-directive-long-press";
window.axios = require("axios");
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import Comment from "./views/nested/Comment.vue";
import SingleComment from "./views/allComments/nested/Comment.vue";
import firebaseMessaging from "./firebase";
/* Core CSS required for Ionic components to work properly */
import "@ionic/vue/css/core.css";

/* Basic CSS for apps built with Ionic */
// import "@ionic/vue/css/normalize.css";
// import "@ionic/vue/css/structure.css";
// import "@ionic/vue/css/typography.css";
import Toast from "vue-toastification";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
const options = {
  position: "top-right",
};
import "../public/assets/css/tailwind.min.css";
import mitt from "mitt";
// import "./registerServiceWorker";
window.HyreadsEvents = mitt();
const app = createApp(App).use(IonicVue).use(store).use(router);
app.use(Toast, options);
app.use(LongPress);
app.component("comment", Comment);
app.component("SingleComment", SingleComment);
app.config.globalProperties.$messaging = firebaseMessaging;
router.beforeEach((to, from, next) => {
  store.state.hide = true;
  store.commit("setLoading", true);

  // Simulate request
  setTimeout(() => {
    next();
  }, 100);
});

router.afterEach(() => {
  store.commit("setLoading", false);
  store.state.hide = false;
});
router.isReady().then(() => {
  app.mount("#app");
});
